import moment from 'moment';

export default () => ({
	description: [''],
	released_at: moment(),
	status_id: 5,
	test_concentrators: [],
});
